<template>
	<div class="forward">
		<div class="forward_title">企业有效发明专利TOP50</div>
		<vue-seamless-scroll :data="regList" :class-option="optionSingleHeightTime" class="seamless-warp">
			<div class="regList" v-for="(item,index) in regList" :key="index">
				<div class="regItem">
					<div class="regItem_title">
						<div class="index">{{index + 1}}</div>
						<div class="title">{{item.zl_qy_fmyoux_top_name}}</div>
					</div>
					<div class="regItem_num">{{item.zl_qy_fmyoux_top_num}}</div>
				</div>
				<el-progress :percentage="Number(item.pec)" :show-text="false"></el-progress>
			</div>
		</vue-seamless-scroll>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				regList:[],
			}
		},
		computed: {
			optionSingleHeightTime () {
				return {
					singleHeight:54,
					waitTime:2500
				}
			}
		},
		mounted() {},
		methods:{
			getData(list){
				this.regList = list
				var max = list[0].zl_qy_fmyoux_top_num
				for(var i in list){
					list[i].pec = ((list[i].zl_qy_fmyoux_top_num / max) * 100).toFixed(2)
				}
			},
		},
	}
</script>

<style  scoped>
	
</style>